"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
const kanban_main_bg_svg_1 = __importDefault(require("./kanban.main.bg.svg"));
const kanban_main_bg_light_svg_1 = __importDefault(require("./kanban.main.bg.light.svg"));
exports.default = theme => ({
    root: {
        display: 'flex',
        boxSizing: 'border-box',
        width: '100%',
        height: `calc(100% - ${constants_1.HEADER_HEIGHT}px)`,
        position: 'fixed',
        zIndex: constants_1.MAIN_FIXED_ZINDEX,
        top: constants_1.HEADER_HEIGHT,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'auto',
        paddingBottom: 'env(safe-area-inset-bottom)',
        paddingLeft: 'env(safe-area-inset-left)',
        paddingRight: 'env(safe-area-inset-right)',
        '-webkit-overflow-scrolling': 'touch',
        opacity: 1,
        transition: 'opacity 250ms linear 250ms',
        '&[aria-busy="true"]': {
            opacity: 0
        }
    },
    bg: {
        position: 'fixed',
        zIndex: constants_1.BG_FIXED_ZINDEX,
        left: 0,
        right: 0,
        bottom: 0,
        top: constants_1.HEADER_HEIGHT,
        overflow: 'hidden',
        backgroundColor: theme.indigo1
    },
    bgLightTheme: {
        backgroundColor: theme.white1
    },
    bgGreyTheme: {
        backgroundColor: theme.grey8
    },
    bgImage: {
        height: `100%`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: `50%`,
        backgroundImage: props => `url(${props.lightTheme ? kanban_main_bg_light_svg_1.default : kanban_main_bg_svg_1.default})`
    },
    bgLoader: {
        height: '100%',
        opacity: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'opacity 250ms linear 250ms',
        '&[data-loading="true"]': {
            opacity: 1
        }
    }
});
//# sourceMappingURL=kanban.main.style.js.map